import { Column, Index, PrimaryGeneratedColumn } from 'typeorm';
import { Entity } from '../../decorators';

/**
 * DomainEntity - Tracks email domains assigned to tenants
 * This is stored in the DVP/shared database to enable lookup
 * of which tenant owns a domain (for email sending verification)
 *
 * Maps to existing table: _domain
 */
@Entity({ name: '_domain' }, { isDvpTable: true })
export class DomainEntity {
	@PrimaryGeneratedColumn({ type: 'int', unsigned: true, name: '_id' })
	id!: number;

	@Column({ type: 'int', unsigned: true, name: '_fk__instance__id' })
	@Index('_domain__fk__instance__id')
	instanceId!: number;

	@Column({ type: 'varchar', length: 65, name: '_domain' })
	domain!: string;

	@Column({ type: 'tinyint', unsigned: true, default: 0, name: '_active' })
	active!: number;

	@Column({ type: 'tinyint', unsigned: true, default: 0, name: '_verified' })
	verified!: number;

	@Column({ type: 'tinyint', default: 0, name: '_public' })
	public!: number;

	@Column({ type: 'tinyint', default: 0, name: '_primary' })
	primary!: number;

	/**
	 * The email provider key whose DKIM/SPF DNS was last confirmed for this
	 * domain (e.g. 'sendgrid', 'aws-ses'). NULL = never validated at a provider.
	 * The send gate only sends from this domain when the value equals the
	 * active provider, so it self-invalidates when the active provider changes.
	 */
	@Column({
		type: 'varchar',
		length: 32,
		nullable: true,
		name: '_validated_sender',
	})
	validatedSender!: string | null;

	get isActive(): boolean {
		return this.active === 1;
	}

	get isVerified(): boolean {
		return this.verified === 1;
	}
}
